module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page wallet"
  }, [_c('pageTitle', {
    attrs: {
      "title": "储值卡修改密码"
    }
  }), _vm._v(" "), _c('inputBox', {
    attrs: {
      "hintMsg": "请输入手机号",
      "disabled": true,
      "label": "手机号"
    },
    model: {
      value: (_vm.userInfo.sjno),
      callback: function($$v) {
        _vm.$set(_vm.userInfo, "sjno", $$v)
      },
      expression: "userInfo.sjno"
    }
  }), _vm._v(" "), _c('inputBox', {
    attrs: {
      "hintMsg": "请设定支付密码",
      "secret": true,
      "label": "新密码"
    },
    model: {
      value: (_vm.passwordnew),
      callback: function($$v) {
        _vm.passwordnew = $$v
      },
      expression: "passwordnew"
    }
  }), _vm._v(" "), _c('inputBox', {
    attrs: {
      "hintMsg": "请再输入一次",
      "secret": true,
      "label": "确认密码"
    },
    model: {
      value: (_vm.passwordcheck),
      callback: function($$v) {
        _vm.passwordcheck = $$v
      },
      expression: "passwordcheck"
    }
  }), _vm._v(" "), _c('inputBox', {
    attrs: {
      "hintMsg": "请输入附加码",
      "label": "附加码",
      "extendType": "icon",
      "extendSrc": _vm.TPFJM
    },
    on: {
      "extendHandler": _vm.getValidateCode
    },
    model: {
      value: (_vm.validCode),
      callback: function($$v) {
        _vm.validCode = $$v
      },
      expression: "validCode"
    }
  }), _vm._v(" "), _c('inputBox', {
    attrs: {
      "hintMsg": "请输入验证码",
      "label": "手机验证码",
      "extendType": "button",
      "extendSrc": "获取验证码",
      "countDownSeconds": _vm.countDown
    },
    on: {
      "extendHandler": _vm.getYZM
    },
    model: {
      value: (_vm.phoneCode),
      callback: function($$v) {
        _vm.phoneCode = $$v
      },
      expression: "phoneCode"
    }
  }), _vm._v(" "), _c('mu-raised-button', {
    style: ({
      width: '96%',
      height: '50px',
      margin: '2%',
    }),
    attrs: {
      "label": "修 改",
      "primary": ""
    },
    on: {
      "click": _vm.change
    }
  }), _vm._v(" "), (_vm.toast) ? _c('mu-toast', {
    attrs: {
      "id": "alertline",
      "message": _vm.TellUser
    },
    on: {
      "close": _vm.hideToast
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-4c6467c0!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/wallet/valueCardPwdReset.vue
// module id = 1494
// module chunks = 18